import { Arrow } from 'react-konva'
import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { DEFAULT_POINTER_SIZE, DEFAULT_STROKE_COLOR } from '../constants'
import { commonShapeProps, ShapeInteraction } from './shapeInteraction'

type Props = {
  shape: Extract<VisualShape, { type: 'arrow' }>
  width: number
  height: number
  interaction?: ShapeInteraction
}

const ArrowShape = ({ shape, width, height, interaction }: Props) => {
  const centerX = shape.x * width
  const centerY = shape.y * height
  const color = shape.stroke_rgb ?? shape.rgb ?? DEFAULT_STROKE_COLOR
  const pixelPoints = shape.points.map((point, i) =>
    i % 2 === 0 ? point * width : point * height,
  )

  return (
    <Arrow
      ref={interaction?.nodeRef}
      x={centerX}
      y={centerY}
      points={pixelPoints}
      rotation={shape.rotation ?? 0}
      fill={shape.fill_rgb ?? color}
      pointerLength={(shape.pointer_length ?? DEFAULT_POINTER_SIZE) * width}
      pointerWidth={(shape.pointer_width ?? DEFAULT_POINTER_SIZE) * width}
      hitStrokeWidth={interaction ? 20 : undefined}
      {...commonShapeProps(shape)}
      draggable={interaction?.draggable ?? false}
      listening={interaction !== undefined}
      onMouseEnter={interaction?.onMouseEnter}
      onMouseLeave={interaction?.onMouseLeave}
      onMouseDown={interaction?.onMouseDown}
      onTap={interaction?.onTap}
      onDragStart={interaction?.onDragStart}
      onDragMove={interaction?.onDragMove}
      onDragEnd={interaction?.onDragEnd}
    />
  )
}

export default ArrowShape
